import * as _ from 'lodash';
import latestCWE from './cwe_latest';

/**
 * This function is used to validate whether or not a CVE is an actual valid CVE identifier
 * TODO: We need to make sure we're accounting for situations where we have `fossa__CVE-XXX-XXXX` or other custom CVE formats
 */
export const isValidCveIdentifier = (id: string): boolean => {
  // Allow for custom identifiers for vulns that do not yet have CVES. They should start with FOSSA_
  return !!id.match(/^(cve|fossa)-\d{4}-\d+$/i);
};

/**
 * isValidCWE ensures that the passed in string is of the shape `CWE-(0-<max CWE>)` where
 * max CWE is retrieved from an auto-generated file that's run during a data scrape.
 */
export const isValidCWE = (cweRaw: string): boolean => {
  const cweRegex = /^(?:cwe|CWE)-([\d]+)$/;
  const cweMatch = cweRegex.exec(cweRaw);
  // No regex match; return false
  if (!cweMatch || !cweMatch[1]) {
    return false;
  }

  // conver to number and check if valid
  const cwe = Number(cweMatch[1]);

  return _.isNumber(cwe) && cwe >= 0 && cwe <= latestCWE;
};
